module.exports = "/_next/static/images/01d59b10a5b10a31fb3b595bc2dba180-Nubank_HickDuarte_55193_xs.jpg";